import kaplay from "kaplay";
import { hideApp } from "./ui/app";
import type { GameSession } from "./client/ws/GameSession";
import { setupGameScene } from "./scenes/gameScene";
import { PANEL_BOTTOM_HEIGHT } from "./scenes/promptPanel";

export function startGame(session: GameSession, isHome: boolean): void {
  hideApp();

  document.body.style.margin = "0";
  document.body.style.overflow = "hidden";

  const headerEl = document.createElement("div");
  headerEl.id = "game-header";
  Object.assign(headerEl.style, {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    height: "56px",
    background: "#08081a",
    borderBottom: "1px solid #2a2a4a",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    zIndex: "80",
    fontFamily: "'Courier New', Courier, monospace",
    boxSizing: "border-box",
    pointerEvents: "none",
  });
  document.body.appendChild(headerEl);

  const canvasWrap = document.createElement("div");
  canvasWrap.id = "canvas-wrap";
  Object.assign(canvasWrap.style, {
    position: "fixed",
    top: "56px",
    left: "0",
    right: "0",
    bottom: `${PANEL_BOTTOM_HEIGHT}px`,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    overflow: "hidden",
    background: "#08081a",
  });
  document.body.appendChild(canvasWrap);

  function getCanvasDimensions(): { w: number; h: number } {
    const wrapW = canvasWrap.clientWidth || window.innerWidth;
    return {
      w: Math.max(Math.min(wrapW, 800), 320),
      h: Math.max(window.innerHeight - 56 - PANEL_BOTTOM_HEIGHT, 200),
    };
  }

  const { w: initW, h: initH } = getCanvasDimensions();

  const k = kaplay({
    background: [8, 8, 18],
    width: initW,
    height: initH,
    scale: 1,
    letterbox: false,
  });

  canvasWrap.appendChild(k.canvas);
  k.canvas.style.display = "block";

  function syncCanvasSize(): void {
    const { w, h } = getCanvasDimensions();
    k.canvas.width = w;
    k.canvas.height = h;
    k.canvas.style.width = `${w}px`;
    k.canvas.style.height = `${h}px`;
  }
  window.addEventListener("resize", syncCanvasSize);

  k.scene("game", () => {
    setupGameScene(k, session, isHome, headerEl);
  });

  k.go("game");
}
